<script setup>
import {useArticles} from "../../store/articles";
import {useRoute} from "vue-router";
import {useSystem} from "../../store/system";
import {onActivated, onMounted} from "vue";

const articleStore = useArticles()
const systemStore = useSystem()
const route = useRoute()
const copyLink = () => {
  let currentHref = window.location.href
  systemStore.copyTxt('.copyBtn', currentHref, 'copy success!', 'copy error!')
}
onActivated(() => {
  articleStore.articlesDetailApi(route.query.article_id)
})
</script>

<template>
  <div>
    <!-- head -->
    <div class="section section--head">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-xl-10 offset-xl-1">
            <div class="section__title">
              <h1>{{articleStore.getArticlesDetail.title}}</h1>
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- article -->
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-xl-10 offset-xl-1">
            <div class="article">
              <el-image class="w-full rounded-lg mb-3" :src="image" fit="cover" v-for="(image, idx) in articleStore.getArticlesDetail.images_list" :key="idx"></el-image>
              <!-- article content -->
              <div class="article__content py-5 tw-overflow-hidden" v-html="articleStore.getArticlesDetail?.content"></div>
              <!-- end article content -->

              <!-- share -->
              <div class="share">
                <a href="Javascript:;" class="share__link share__link--fb copyBtn" @click="copyLink"><i class="ti ti-brand-facebook"></i> share</a>
                <a href="Javascript:;" class="share__link share__link--tw copyBtn" @click="copyLink"><i class="ti ti-brand-x"></i> tweet</a>
                <a href="Javascript:;" class="share__link share__link--link copyBtn" @click="copyLink"><i class="ti ti-link"></i> <span>copy link</span></a>
              </div>
              <!-- end share -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end article -->

  </div>
</template>

<style scoped>

</style>
